import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/_Pages/Portfolio/Custom/BritishLand/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/_Pages/Portfolio/index.tsx");
